import React from "react";
import { classNames } from "../../helpers";

export default function TwCheckBox(props) {
  const { children, className = "", name = "", errors = {}, error = "", title = "", subTitle = "" } = props
  let inputProps = { ...props }
  delete inputProps.leftIcon
  delete inputProps.rightIcon
  delete inputProps.errors
  delete inputProps.subTitle
  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  let inputLableClass = "text-black/[0.6]"
  let inputClass = ""

  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "border-red-900"
  }
  return (
    <div className="flex gap-3">
      <div className="flex h-6 shrink-0 items-center">
        <div className="group grid size-4 grid-cols-1">
          <input
            {...inputProps}
            type="checkbox"
            // aria-describedby="comments-description"
            className={classNames("col-start-1 row-start-1 appearance-none rounded  bg-white border border-gray-300 checked:border-primary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto",
              inputClass
            )}
          />
          <svg
            fill="none"
            viewBox="0 0 14 14"
            className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
          >
            <path
              d="M3 8L6 11L11 3.5"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="opacity-0 group-has-[:checked]:opacity-100"
            />
            <path
              d="M3 7H11"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="opacity-0 group-has-[:indeterminate]:opacity-100"
            />
          </svg>
        </div>
      </div>
      <div className="text-sm/6">
        <label htmlFor={inputProps.name} className={classNames("font-medium text-gray-900", inputLableClass)}>
          {title}
        </label>
        {subTitle && (<p id="comments-description" className="text-gray-500">
          {subTitle}
        </p>)}
      </div>
    </div>
  );
}
